// Central, single-source content for Amanah Promotions Limited.

export const COMPANY = {
  name: "Amanah Promotions Limited",
  shortName: "Amanah Promotions",
  number: "17348092",
  incorporated: "20 July 2026",
  office:
    "Laxton House, 191 Lincoln Road, Peterborough, England, PE1 2PN",
  website: "amanahpromotions.com",
  email: "hello@amanahpromotions.com",
  hours: "Monday to Saturday, 9:00am\u20136:00pm",
  area: "England and Wales",
  strapline: "Ethical Fundraising. Measurable Impact.",
};

// Primary site navigation. Section entries scroll the homepage.
export const NAV = [
  { label: "Home", to: "/", section: "top" },
  { label: "For Charities", to: "/", section: "for-charities" },
  { label: "How We Work", to: "/", section: "how-we-work" },
  { label: "About Amanah", to: "/", section: "about" },
  { label: "Join Our Team", to: "/join-our-team" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    title: "Face-to-face donor acquisition",
    body: "Trained fundraisers engaging the public respectfully to introduce your cause and invite committed support.",
  },
  {
    title: "Regular-giving campaigns",
    body: "Programmes designed to build dependable, long-term giving relationships rather than one-off gifts.",
  },
  {
    title: "Campaign planning and mobilisation",
    body: "Clear objectives, a defined supporter journey and a delivery plan ready to activate in the field.",
  },
  {
    title: "Fundraiser recruitment and training",
    body: "Carefully selected people, prepared to represent your charity with knowledge and integrity.",
  },
  {
    title: "Field-team management",
    body: "Day-to-day leadership and support that keeps teams motivated, compliant and on-message.",
  },
  {
    title: "Quality assurance",
    body: "Standards, checks and safeguards that protect both your reputation and the public.",
  },
  {
    title: "Campaign monitoring and reporting",
    body: "Structured oversight of activity, quality and outcomes so progress is always visible.",
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Understand",
    body: "We begin with the charity\u2019s objectives, audience, proposition and operational requirements.",
  },
  {
    no: "02",
    title: "Design",
    body: "We create a suitable campaign approach, supporter journey and delivery plan.",
  },
  {
    no: "03",
    title: "Deliver",
    body: "Trained fundraisers represent the charity professionally through respectful public engagement.",
  },
  {
    no: "04",
    title: "Monitor",
    body: "Campaign activity, quality and outcomes are reviewed through structured oversight and reporting.",
  },
];

export const WHY = [
  "Ethical fundraising",
  "Respectful public engagement",
  "Experienced campaign leadership",
  "Carefully selected and supported fundraisers",
  "Clear accountability",
  "Structured campaign visibility",
  "Long-term donor quality over short-term volume",
];

export const LEGAL_LINKS = [
  { label: "Privacy Notice", to: "/privacy" },
  { label: "Cookie Information", to: "/cookies" },
  { label: "Website Terms", to: "/terms" },
  { label: "Accessibility Statement", to: "/accessibility" },
  { label: "Complaints Procedure", to: "/complaints" },
];

// One deliberate, non-fabricated architectural frame (navy-treated).
export const ARCH_IMAGE =
  "https://images.unsplash.com/photo-1761075349515-756d51d30973?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
